import { For, Show, createSignal, onCleanup } from 'solid-js';
import {
  feedbackLine,
  nextBlindfoldPuzzle,
  pieceNotation,
  type BlindfoldPuzzle,
} from '@domain/blindfold/puzzle';
import type { Square } from '@domain/chess/types';
import { recordModeAttempt } from '@state/modeStore';
import { newGame } from '@state/actions';
import './BlindfoldQuiz.css';

export function BlindfoldQuiz() {
  const [puzzle, setPuzzle] = createSignal<BlindfoldPuzzle>(nextBlindfoldPuzzle());
  const [picked, setPicked] = createSignal<Square | null>(null);

  onCleanup(() => {
    newGame();
  });

  function loadNext() {
    const current = puzzle();
    setPuzzle(
      nextBlindfoldPuzzle(Math.random, {
        exclude: { piece: current.piece, from: current.from },
      }),
    );
    setPicked(null);
  }

  function onChoice(sq: Square) {
    const already = picked();
    if (already) {
      if (sq === already) loadNext();
      return;
    }
    const p = puzzle();
    recordModeAttempt('blindfold', sq === p.answer);
    setPicked(sq);
  }

  return (
    <>
      <section class="game-rules" aria-label="Game rules">
        <p>Find the reachable square.</p>
      </section>
      <div class="blindfold">
        <p class="blindfold__piece" aria-label="Piece">
          {pieceNotation(puzzle())}
        </p>
        <div class="blindfold__choices" role="group" aria-label="Square choices">
          <For each={puzzle().choices}>
            {(sq) => (
              <button
                type="button"
                class="btn blindfold__choice"
                disabled={picked() !== null && picked() !== sq}
                onClick={() => onChoice(sq)}
              >
                {picked() === sq ? 'Next' : sq}
              </button>
            )}
          </For>
        </div>
        <p class="blindfold__feedback" aria-live="polite">
          <Show when={picked()}>
            {(sq) => feedbackLine(puzzle(), sq())}
          </Show>
        </p>
      </div>
    </>
  );
}
